export const POKEMON_PAGE_SIZE = 12;

export const DEFAULT_POKEMON_PAGE = `?offset=0&limit=${POKEMON_PAGE_SIZE}`;

export const POKEMON_STATS = [
  { key: "hp", label: "Health", from: "#ef4444", to: "#f97316" },
  { key: "attack", label: "Attack", from: "#f97316", to: "#f59e0b" },
  { key: "defense", label: "Defense", from: "#14b8a6", to: "#0ea5e9" },
  { key: "special-attack", label: "Sp. Attack", from: "#3b82f6", to: "#6366f1" },
  { key: "special-defense", label: "Sp. Defense", from: "#22c55e", to: "#10b981" },
  { key: "speed", label: "Speed", from: "#8b5cf6", to: "#d946ef" },
];
